import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_JOBS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the jobs.'),
      403: i18n.t('You are not allowed to fetch the jobs.'),
      404: i18n.t('The jobs you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the jobs.'),
      default: i18n.t('An error occurred fetching the jobs.')
    }
  },
  CANCEL_JOB: {
    ERROR: {
      401: i18n.t('You are not authorized to cancel the job.'),
      403: i18n.t('You are not allowed to cancel the job.'),
      404: i18n.t('The job you are trying to cancel does not exist.'),
      500: i18n.t('There was an error canceling the job.'),
      default: i18n.t('An error occurred canceling the job.')
    },
    SUCCESS: {
      200: i18n.t('Job cancelled successfully.')
    }
  },

  CREATE_JOB: {
    ERROR: {
      401: i18n.t('You are not authorized to create this job.'),
      403: i18n.t('You are not allowed to create this job.'),
      500: i18n.t('An error occurred while creating the job.'),
      default: i18n.t('An error occurred while creating the job.')
    },
    SUCCESS: {
      200: i18n.t('The job was created successfully.')
    }
  },

  CREATE_JOBS: {
    ERROR: {
      401: i18n.t('You are not authorized to create these jobs.'),
      403: i18n.t('You are not allowed to create these jobs.'),
      500: i18n.t('An error occurred while creating the jobs.'),
      default: i18n.t('An error occurred while creating the jobs.')
    },
    SUCCESS: {
      200: i18n.t('The jobs were created successfully.')
    }
  }
};
